import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ResultGuard} from './core/guard/result.guard';
import {HomeGuard} from './core/guard/home.guard';
import {DirectModuleSelectionGuard} from './core/guard/direct-module-selection.guard';
import {LandingPageComponent} from './landing-page/landing-page.component';
import {LandingPageGuard} from './core/guard/landing-page.guard';

const appRoutes: Routes = [
  {
    path: 'direct/:module',
    canActivate: [DirectModuleSelectionGuard],
    children: []
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    canActivate: [HomeGuard]
  },
  {
    path: 'analyzer',
    loadChildren: () =>
      import('./analysis/analysis.module').then(m => m.AnalysisModule)
  },
  {
    path: 'result',
    loadChildren: () =>
      import('./result/result.module').then(m => m.ResultModule),
    canActivate: [ResultGuard]
  },
  {
    path: 'cockpit',
    loadChildren: () =>
      import('./cockpit/cockpit.module').then(m => m.CockpitModule),
    canActivate: [ResultGuard]
  },
  {
    path: '',
    component: LandingPageComponent,
    loadChildren: () =>
      import('./landing-page/landing-page.module').then(
        m => m.LandingPageModule
      ),
    canActivate: [LandingPageGuard]
  },
  {path: '**', redirectTo: '', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, {})],
  exports: [RouterModule]
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class AppRoutingModule {}
